import { STATS_API } from "@/constants/env";

export const fetchSearchResults = async ({
  query,
  accessToken,
  limit,
}: {
  query: string;
  accessToken: string;
  limit?: number;
}) => {
  const response = await fetch(
    `${STATS_API}/search?query=${encodeURIComponent(query)}${limit ? `&limit=${limit}` : ""}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );
  const data = await response.json();

  // Skip transactions for now
  delete data["Transactions"];
  delete data["Transaction Errors"];

  return data;
};
